<template>
  <section class="profile">
    <background-tilt />
    <div class="intro-box" ref="textbox">
      <headline
        kicker="Profil & Vision"
        headline="Worauf wir stolz sind"/>
      <div class="wrap">
        <div class="image-box">
          <img src="./../assets/images/profile/thumb.jpg" alt="">
        </div>
        <div class="text-box">
          <p>Lernen Sie unsere Vision, unsere Mission und unsere Strategie kennen. Und erfahren Sie, welche Produkte und Dienstleistungen wir unseren Kundinnen und Kunden anbieten.</p>
          <button-link router-link="/profil/details/" label="mehr erfahren" />
        </div>
      </div>
    </div>
    <div class="counter-box">
      <profile-counter />
    </div>
    <div class="facts-wrapper">
      <profile-paternoster />
    </div>
  </section>
</template>

<script>
  import Headline from "../elements/Headline";
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';
  import BackgroundTilt from "../elements/BackgroundTilt";
  import ProfileCounter from "../elements/ProfileCounter";
  import ButtonLink from "../elements/ButtonLink";
  import ProfilePaternoster from "../elements/ProfilePaternoster";
  gsap.registerPlugin(ScrollTrigger);

  export default {
    name: "SectionProfile",
    components: {ProfilePaternoster, ButtonLink, ProfileCounter, BackgroundTilt, Headline},
  }
</script>

<style scoped>
  .profile {
    position: relative;
    height: 100%;
    z-index: 1;
    display: flex;
    padding: 0 calc(120px + 4vw);
  }
  .intro-box {
    position: relative;
    display: block;
    margin-right: 180px;
    padding-top: 16px;
  }
  .wrap {
    display: flex;
    width: 520px;
    color: #102D61;
    margin: 30px 0;
  }
  .wrap .image-box {
    position: relative;
    display: block;
    min-width: 180px;
    margin-right: 30px;
  }
  .wrap .image-box:before {
    content: "";
    position: relative;
    display: block;
    padding-top: 133.3333%;
    background-color: #ccc;
  }
  .intro-box p {
    margin-top: -4px;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 999px) {
    section {
      background-color: white;
      transform: translate3d(0, 0, 0);
    }
    section:before {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      width: 120vw;
      height: 25vh;
      transform-origin: 100% 0;
      transform: rotate(-8deg);
      background-color: #fff;
    }
    .background-tilt {
      display: none;
    }
    .profile {
      padding: 30px 20px;
      display: block;
    }
  }
  @media(max-width: 999px) and (min-width: 568px) {
    .intro-box {
      width: 540px;
      margin: 40px auto;
    }
    .counter-box {
      width: 540px;
      margin: 80px auto;
    }
  }
  @media(max-width: 567px) {
    .intro-box {
      margin-right: 0;
      margin-top: 30px;
    }
    .wrap {
      display: block;
      width: auto;
    }
    .wrap .image-box {
      margin-bottom: 36px;
    }
    .wrap .image-box:before {
      padding-top: 60%;
    }
  }
</style>